// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--WcV7O","info":"a10a3f92e9--info--aKHzP","genplan":"a10a3f92e9--genplan--eukGX","about-button":"a10a3f92e9--about-button--jVZO6"};